import React from "react";
import "./styles.component.ui.less";
import { useTranslation } from "react-i18next";
import { industrys } from "./themeData.js";
import classNames from "classnames";

export const Card = ({ children, unvalid, title, className }) => {
  return (
    <div className="home-guard-item-card">
      <div
        className={classNames(
          unvalid
            ? "home-guard-item-card-warp unvalid"
            : "home-guard-item-card-warp",
          className
        )}
      >
        {title && <div className="home-guard-card-title">{title}</div>}
        {children}
      </div>
    </div>
  );
};
export const Checkbox = ({ checked, label }) => {
  return (
    <div className="home-guard-item-checkbox">
      <div className={checked ? "full checked" : "full"}>
        {checked && (
          <div className="trigger">
            <i className="icon authing-icon authing-check-line"></i>
          </div>
        )}
      </div>

      <label>{label}</label>
    </div>
  );
};
export const Radio = ({ checked, label, style }) => {
  return (
    <div className="home-guard-item-radio" style={style}>
      <div className={checked ? "full checked" : "full"}>
        {checked && <div className="trigger"></div>}
      </div>
      <label>{label}</label>
    </div>
  );
};
export const Switch = ({ label }) => {
  return (
    <div className="home-guard-item-switch">
      <div>{label}</div>
      <div className="switch-button">
        <div className="bottom"></div>
        <div className="trigger"></div>
      </div>
    </div>
  );
};
export const GuardUi = ({ theme }) => {
  const { t } = useTranslation();
  return (
    <div className="guard-login-ui">
      <div
        className="guard-ui-icon"
        style={{ background: theme.icon ? "" : "#ecedf2" }}
      >
        <i
          className={`icon website-icon ${theme.icon}`}
          style={{ fontSize: 28, color: theme.color }}
        ></i>
      </div>
      <div className="guard-ui-title">
        {t("homePage.guard.guard-ui.center.title")}
      </div>
      <div className="guard-ui-tabs">
        <span
          className="checked"
          style={{
            color: theme.color,
            borderBottomColor: theme.color,
          }}
        >
          {t("homePage.guard.guard-ui.center.passLogin")}
        </span>
        <span>{t("homePage.guard.guard-ui.center.rcode")}</span>
      </div>
      <div className="guard-ui-input">
        <i className="icon website-icon website-user-line"></i>
        <span>{t("homePage.guard.guard-ui.center.account")}</span>
      </div>
      <div className="guard-ui-input">
        <i className="icon website-icon website-lock-line"></i>
        <span>{t("homePage.guard.guard-ui.center.password")}</span>
      </div>
      <div
        className="guard-ui-button"
        style={{
          background: theme.color,
        }}
      >
        <span>{t("homePage.guard.guard-ui.center.login")}</span>
      </div>
      <div
        className="guard-ui-other"
        style={{
          color: theme.color,
        }}
      >
        <span>{t("homePage.guard.guard-ui.center.forgetPass")}</span>
        <span>{t("homePage.guard.guard-ui.center.regist")}</span>
      </div>
      <div className="guard-ui-third">
        <div className="guard-ui-third-title">
          {t("homePage.guard.guard-ui.center.thirdLogin")}
        </div>
        <div className="guard-ui-third-icon">
          {theme.thirdIcon?.map((item) => (
            <div>
              <img alt="" src={`//files.authing.co/authing-website/${item}`} />
            </div>
          ))}
        </div>
      </div>
      <div className="guard-ui-lang">
        {t("homePage.guard.guard-ui.center.lang")}
      </div>
    </div>
  );
};
export const GuardButton = ({ theme, setTheme, setColor }) => {
  const { t } = useTranslation();
  return (
    <div className="guard-button-warp">
      {industrys.map((item) => {
        const className = classNames({
          "guard-theme-button": true,
          checked: theme.theme === item.theme,
        });
        return (
          <div
            className={className}
            onClick={() => {
              setTheme(item);
              item.theme === "owner"
                ? setColor("#ECEDF2")
                : setColor(item.color);
            }}
          >
            {t(item.label)}
          </div>
        );
      })}
    </div>
  );
};
